module.exports = __webpack_public_path__ + "static/img/miner-mk-1_256.9be28d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miner-mk-1_256.png
// module id = B/W7
// module chunks = 0